export enum ModalType {
  'SUPPORTED_SNACKS' = 'SUPPORTED_SNACKS',
  'PERMISSION' = 'PERMISSION'
}
